import { DailyFactoryOptions } from "@daily-co/daily-js";
import { getStoredMediaSettings } from "../../../services/LocalStorage";
import { DAILY_URL_PREFIX } from "../../../utils/constants";

export function generateCallOptions(roomName: string, token: string | null) {
  const storedMediaSettings = getStoredMediaSettings();
  const callOptions: DailyFactoryOptions = {
    url: DAILY_URL_PREFIX + roomName,
    userName: storedMediaSettings?.userName,
    startAudioOff: !storedMediaSettings?.isMicEnabled,
    startVideoOff: !storedMediaSettings?.isCameraEnabled,
    audioSource: storedMediaSettings?.selectedMicId,
    videoSource: storedMediaSettings?.selectedCameraId,
    subscribeToTracksAutomatically: true,
    dailyConfig: {
      userMediaVideoConstraints: {
        aspectRatio: 1,
      }
    },
    sendSettings: { video: { encodings: { low: { maxBitrate: 600000, maxFramerate: 30 }}}},
  }
  if (token) callOptions.token = token;
  return callOptions;

}
